import { departmentFilter } from 'containers/Pages/People/Personnel/Layouts/options.jsx';
import API from 'services/api';
import { isEmpty } from 'lodash';
import { getAssetName } from 'containers/Pages/Assets/Assets';
import { getPurposeName } from 'containers/Pages/Locations/Visitors/visitorHelper';
import { v4 } from 'uuid';

export const filters = ({
  site,
  minDate = undefined,
  userAssignedDepartments = [],
}) => {
  const departmentFilterField = departmentFilter(userAssignedDepartments);
  return {
    RegularFilters: [
      {
        label: 'Current visitors only',
        field: 'showCurrentVisitsOnly',
        type: 'toggle',
      },
      {
        label: 'Site',
        field: 'site',
        useAsyncInFilters: true,
        type: 'async-select',
        fetchOptions: API.fetchSitesList,
        dataTransform: ({ data }) => {
          return data;
        },
        fetchFilters: {
          archived: false,
        },
        multiple: false,
        optionLabelKey: 'name',
        required: false,
      },
      {
        label: 'Date From',
        field: 'dateFrom',
        type: 'date-picker',
      },
      {
        label: 'Date To',
        field: 'dateTo',
        type: 'date-picker',
        minDate,
      },
    ],
    AdvancedFilters: [
      ...departmentFilterField,
      {
        label: 'Type',
        field: 'type',
        type: 'async-select',
        useAsyncInFilters: true,
        fetchOptions: API.fetchVisitorTypes,
        fetchFilters: { archived: false },
        optionLabelKey: 'typeName',
        dataTransform: ({ data }) => {
          return data; //no need to transform since it has id and typeName?
        },
      },
      {
        label: 'Visitor',
        field: 'visitor',
        useAsyncInFilters: true,
        type: 'async-select',
        fetchOptions: API.getPreviousVisitorList,
        dataTransform: ({ data }) => {
          if (!isEmpty(data)) {
            return data.map(v => ({
              ...v,
              name: `${v.firstName} ${v.lastName}`,
            }));
          }
          return data;
        },
        fetchFilters: {
          archived: false,
          site: site,
        },
        multiple: false,
        optionLabelKey: 'name',
        required: false,
        resetWhen: [
          {
            value: site,
            condition: val => {
              return val;
            },
          },
        ],
      },
      {
        label: 'Purpose',
        field: 'purpose',
        useAsyncInFilters: true,
        type: 'async-select',
        fetchOptions: API.getPurposeList,
        dataTransform: ({ data }) => {
          if (!isEmpty(data)) {
            return data.map(p => ({
              id: v4(),
              name: getPurposeName(p),
            }));
          }
          return data;
        },
        fetchFilters: {
          archived: false,
          site: site,
        },
        multiple: false,
        optionLabelKey: 'name',
        required: false,
        resetWhen: [
          {
            value: site,
            condition: val => {
              return val;
            },
          },
        ],
      },
      {
        label: 'Destination',
        field: 'destination',
        useAsyncInFilters: true,
        type: 'async-select',
        fetchOptions: API.getAssetList,
        dataTransform: ({ data }) => {
          if (!isEmpty(data)) {
            return data.map(a => ({
              id: a.id,
              name: getAssetName(a),
            }));
          }
          return data;
        },
        fetchFilters: {
          archived: false,
          category: 'ROOM',
        },
        multiple: false,
        optionLabelKey: 'name',
        required: false,
        resetWhen: [
          {
            value: site,
            condition: val => {
              return val;
            },
          },
        ],
      },
    ],
  };
};
